import { createRemittanceConfig } from "cy-remittance-config";

/**
 * Tourvest Money remittance configuration.
 */
export const remittanceConfig = createRemittanceConfig({
  companyName: "Tourvest Money",
  shortCompanyName: "TourvestMoney",
  contactDetails: {
    supportEmail: "help@tourvest.co.za",
    supportPhone: {
      display: "+27 11 728 0540",
      value: "+27117280540",
    },
    infoEmail: "info@tourvest.co.za",
    whatsappNumber: "081 000 0000",
  },
});
